import { render } from "./PSendInvite.vue?vue&type=template&id=f9414c10"
import script from "./PSendInvite.vue?vue&type=script&lang=js"
export * from "./PSendInvite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__